module.exports = __webpack_public_path__ + "static/img/branding-promot.2c89b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/branding-promot.png
// module id = AXlL
// module chunks = 1